export const CROP_VERTICAL_9_16 = 9 / 16;
export const CROP_SQUARE_1_1 = 1 / 1;
